export default {
  REVIEW_CONTACT_INFO: 'REVIEW_CONTACT_INFO',
  REVIEW_CONTACT_INFO_SUCCESS: 'REVIEW_CONTACT_INFO_SUCCESS',
  REVIEW_CONTACT_INFO_FAILURE: 'REVIEW_CONTACT_INFO_FAILURE',
};
